import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaSquareXTwitter,
} from "react-icons/fa6";
import classes from "./SocialSection.module.css";

export const socialLinks = [
  {
    href: "https://www.facebook.com/MedicaIImagingTechnology/",
    label: "Facebook",
    icon: <FaFacebookF />,
  },
  {
    href: "https://x.com/imaging_MIT",
    label: "X",
    icon: <FaSquareXTwitter />,
  },
  {
    href: "https://www.linkedin.com/company/medicalimagingtechnology",
    label: "LinkedIn",
    icon: <FaLinkedinIn />,
  },
  {
    href: "https://www.instagram.com/medicalimaging101/",
    label: "Instagram",
    icon: <FaInstagram />,
  },
];

export default function SocialSection({
  links = socialLinks,
  variant = "dark",
  show = true,
}) {
  if (!show) return null;

  const rootClass =
    variant === "light"
      ? `${classes.socialIcons} ${classes.light}`
      : classes.socialIcons;

  return (
    <div className={rootClass} aria-label="Social media links">
      {links.map((item) => (
        <a
          key={item.label}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={item.label}
        >
          {item.icon}
        </a>
      ))}
    </div>
  );
}
